


















































import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetMachineSmartLockEventsHistoryCommand } from "@/model/communication/oneTimeCode/GetMachineSmartLockEventsHistoryCommand";
import { GetMachineSmartLockEventsHistoryResData } from "@/model/communication/oneTimeCode/GetMachineSmartLockEventsHistoryResData";
import { GetI18nStringFromMachineEventType } from "@/model/data/enums/MachineEventTypeEnum";
import { GetI18nStringFromUserEventType } from "@/model/data/enums/UserEventTypeEnum";
import { Brand_Red } from "@/utility/Constants";

export default Vue.extend({
    props: {
        installationName: String,
        machineSerialNumber: String,
        loading: Boolean,
    },
    data() {
        return {
            Brand_Red,
            moment,
            eventsCount: 5,
            eventsList: null,
            eventHistoryLoading: false,
            showHistory: false,
            loadingShowMore: false,
            totalEventsCount: 0,
        };
    },
    watch: {
        machineSerialNumber: {
            handler(val) {
                this.eventsCount = 5;
                this.eventsList = null;
                this.showHistory = false;
                this.sendGetMachineSmartLockEventsHistoryRequest(val);
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        ...mapGetters(["longDateFormat"]),
    },
    methods: {
        GetI18nStringFromMachineEventType,
        GetI18nStringFromUserEventType,
        async sendGetMachineSmartLockEventsHistoryRequest() {
            try {
                if (!this.loadingShowMore) this.eventHistoryLoading = true;
                let response: GetMachineSmartLockEventsHistoryResData = await new GetMachineSmartLockEventsHistoryCommand(
                    this.installationName,
                    this.machineSerialNumber,
                    this.eventsCount
                ).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    let userEventsCounter = 0;
                    let machineEventsCounter = 0;
                    this.totalEventsCount = response.totalEvents;
                    this.eventsList = [];
                    while (userEventsCounter < response.userEvents.length || machineEventsCounter < response.machineEvents.length) {
                        let userEvent = response.userEvents[userEventsCounter];
                        let machineEvent = response.machineEvents[machineEventsCounter];

                        if (!machineEvent || (userEvent && userEvent.timestamp > machineEvent.eventTimestamp)) {
                            this.eventsList.push({
                                timestamp: moment.utc(userEvent.timestamp).local(),
                                eventType: this.$t(this.GetI18nStringFromUserEventType(userEvent.eventType)),
                            });
                            userEventsCounter += 1;
                        } else {
                            this.eventsList.push({
                                timestamp: machineEvent.eventTimestamp,
                                eventType: this.$t(this.GetI18nStringFromMachineEventType(machineEvent.eventType)),
                            });
                            machineEventsCounter += 1;
                        }
                    }
                    this.eventsList = this.eventsList.sort((a: any, b: any) => {
                        return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
                    });
                    this.eventHistoryLoading = false;
                }
            } catch (e) {
                console.log("Something went wrong sending GetMachineSmartLockEventsHistory request ", e);
            }
        },
        async showMore() {
            this.loadingShowMore = true;
            this.eventsCount += 5;
            await this.sendGetMachineSmartLockEventsHistoryRequest();
            this.loadingShowMore = false;
        },
    },
});
